import { BREAKPOINT_MIN_FROM, BrowserSize } from './browser';
import type { SwiperBreakpoints } from './coopSwiperBreakpoints';
import { getSwiperBreakpoint } from './coopSwiperBreakpoints';

export class CoopSwiperBreakpointsUnique {
    public static readonly AREA_MINICART = 'MiniCart';

    public static readonly AREA_CHECKOUT_STEP_2 = 'CheckoutStep2';

    public static readonly AREA_RECIPE_MODAL = 'RecipeModal';

    static getUniqueBreakpointsFor(uniqueArea: keyof SwiperBreakpointsCollectionUnique) {
        return UNIQUE_AREA_BREAKPOINTS[uniqueArea];
    }
}

interface SwiperBreakpointsCollectionUnique {
    MiniCart: {
        ProductList: SwiperBreakpoints;
    };
    CheckoutStep2: {
        ProductList: SwiperBreakpoints;
    };
    RecipeModal: {
        ProductList: SwiperBreakpoints;
    };
}

const UNIQUE_AREA_BREAKPOINTS: SwiperBreakpointsCollectionUnique = {
    MiniCart: {
        ProductList: {
            [BREAKPOINT_MIN_FROM]: {
                slidesPerView: 2.1,
                slidesPerGroup: 2,
            },
            [getSwiperBreakpoint(BrowserSize.sm)]: {
                slidesPerView: 2.5,
                slidesPerGroup: 2,
            },
        },
    },
    CheckoutStep2: {
        ProductList: {
            [BREAKPOINT_MIN_FROM]: {
                slidesPerView: 2.1,
                slidesPerGroup: 2,
            },
            [getSwiperBreakpoint(BrowserSize.sm)]: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            [getSwiperBreakpoint(BrowserSize.xlg)]: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },
    },
    RecipeModal: {
        ProductList: {
            [BREAKPOINT_MIN_FROM]: {
                slidesPerView: 2.1,
                slidesPerGroup: 2,
            },
            [getSwiperBreakpoint(BrowserSize.xsm)]: {
                slidesPerView: 2.5,
                slidesPerGroup: 2.5,
            },
            [getSwiperBreakpoint(BrowserSize.sm)]: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            [getSwiperBreakpoint(BrowserSize.md)]: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },
    },
};
